import { TViewMode } from '../../ProjectsOnMap/ProjectsOnMap';
import { NEWBUILDING_CARD_SEE_ALL_BUTTON_LINK } from '../constants';

export function handleSeeAllLink(mode: TViewMode, onSeeAllClick: () => void) {
  // istanbul ignore if
  if (mode !== 'newBuildings') {
    return;
  }

  const seeAllLink = document.getElementById(NEWBUILDING_CARD_SEE_ALL_BUTTON_LINK);

  // istanbul ignore else
  if (seeAllLink) {
    seeAllLink.onclick = onSeeAllClick;
  }
}
